import { jsx as _jsx } from "react/jsx-runtime";
import { between } from '@iotv/core-services';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { ActionIcons } from '../../../Iconography';
const debug = process.env.REACT_APP_DEBUG && false;
/** A low level hook to export data to sheets, the data is provided and exported is unmanipulated */
export const useGoogleSpreadsheetDataExport = ({ setRequest: setRequestIn, provideExportButton, spreadsheetData }) => {
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const [working, setWorking] = useState(false);
    const { range, spreadsheetId, valueInputOption = 'USER_ENTERED', majorDimension = 'ROWS' } = setRequestIn ?? {};
    const setSpreadsheetData = async ({ setRequest }) => {
        debug && console.log('useGoogleSpreadsheetDataExport, setSpreadsheetData', { setRequest, spreadsheetData });
        const result = { err: null, data: null };
        try {
            setWorking(true);
            setSuccess(null);
            const { range, spreadsheetId } = setRequest;
            const request = { range, spreadsheetId, valueInputOption };
            const body = {
                range,
                values: spreadsheetData,
            };
            const { status: clearStatus } = await gapi.client.sheets.spreadsheets.values.clear({ range, spreadsheetId }, { range });
            const { result, status, statusText } = await gapi.client.sheets.spreadsheets.values.update(request, body);
            if (between(status, 200, 203)) {
                console.log({ result, status, statusText });
                setSuccess(true);
                setError(null);
            }
            else {
                console.log({ result, status, statusText });
                setError(new Error(statusText));
                setSuccess(false);
            }
        }
        catch (error) {
            console.log('Err Caught Error', error?.result);
            console.log('Payload was', { setRequest, valueRangeBody: { range, values: spreadsheetData } });
            setError(error.result.error);
        }
        setWorking(false);
        return result;
    };
    const WorkingSpinner = working ? _jsx(CircularProgress, { size: "1.5em" }) : null;
    /** if ExportButton is requested, it is the only element that will call getSpreadsheetData */
    const ExportButton = provideExportButton && setRequestIn ? (_jsx(Tooltip, { title: 'Export to selected sheet', children: _jsx(IconButton, { onClick: () => {
                setSpreadsheetData({ setRequest: setRequestIn });
            }, children: _jsx(ActionIcons.Export, {}) }) })) : null;
    useEffect(() => {
        /** if ExportButton is not requested, getSpreadsheetData will be called on every change in params (eg user chooses different sheet) */
        if (!provideExportButton) {
            if (spreadsheetId && range) {
                setSpreadsheetData({ setRequest: { spreadsheetId, range, majorDimension, valueInputOption } });
            }
        }
    }, [spreadsheetId, range, majorDimension, valueInputOption]);
    return {
        state: { error },
        handlers: { clearError: () => setError(null) },
        components: { WorkingSpinner, ExportButton },
    };
};
